export const getInvoice = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      # owner removed 1.3.12
      groups
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      paymentTermId
      paymentTerm {
        name
        code
        type
        dueDays
        dayOfMonthDue
        sortKey
      }
      paymentTerms
      dueDate
      overDue
      sentDate
      paidDate
      # default nested limit is 100; ~640 B per line keeps 1000 under the 1 MB page
      lineItems(limit: 1000) {
        items {
          id
          # owner removed 1.3.12
          groups
          accountId
          reloadYardId
          invoiceId
          serviceId
          service {
            name
          }
          externalId
          sortKey
          quantity
          units
          unitCost
          amount
          itemTax
          taxRate {
            taxCode
            taxRate
          }
          serviceNote
          serviceDate

          inboundShipmentId
          inboundShipment {
            poNumber
            history {
              type
              date
              by
              text
            }
          }
          outboundShipmentId
          outboundShipment {
            poNumber
            history {
              type
              date
              by
              text
            }
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      contact {
        name
        email
        phone
      }
      accountName
      accountId
      account {
        id
        # owner removed 1.3.12
        groups
        active
        status
        lotNumberPrefix
        businessName
        displayName
        paymentTermId
        overLimit
        overDue
        email
        phone
        # fax
        # website
        externalId
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        reloadYardId
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
        }
        createdAt
        updatedAt
      }
      attachments {
        bucket
        region
        key
        type
      }
      reloadYardId
      reloadYard {
        id
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        taxRates {
          taxCode
          taxRate
        }
        # invoiceNumberPrefix
        # invoiceCounter
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        logoImage {
          bucket
          region
          key
        }
      }
      inboundShipmentId
      # used for detailed invoice memoe / manifest
      inboundShipment {
        shipFrom
        carrierName
        railCarNumber
        totalUOM
        tareWeight
        ladenWeight
        scaleWeightUnits
        placedDateTime
        releaseDateTime
        inventories {
          items {
            productCode
            productName
            quantityAdvised
            quantityReceived
            lotNumber
            customFields
          }
        }
        customFields
      }
      outboundShipmentId
      # used for detailed invoice memoe / manifest
      outboundShipment {
        pickupNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
        }
        carrierName
        bolNumber
        railCarNumber
        departureDateTime
        tareWeight
        ladenWeight
        scaleWeightUnits
        totalUOM
        sealNumber
        shipmentLineItems {
          items {
            sortKey
            totalQuantityToPick
            inventoryId
            inventory {
              productCode
              productName
              lotNumber
            }
          }
          nextToken
        }
        customFields
      }
      createdAt
      updatedAt
    }
  }
`;

export const getInvoiceForSend = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      active
      status
      invoiceNumber
      externalId
      externalUrl
      externalStatus
      poNumber
      paymentTermId
      paymentTerm {
        name
        code
      }
      paymentTerms
      dueDate
      sentDate
      paidDate
      # default nested limit is 100; ~640 B per line keeps 1000 under the 1 MB page
      lineItems(limit: 1000) {
        items {
          id
          serviceId
          service {
            name
          }
          externalId
          sortKey
          quantity
          units
          unitCost
          amount
          itemTax
          taxRate {
            taxCode
            taxRate
          }
          serviceNote
          serviceDate

          inboundShipmentId
          inboundShipment {
            poNumber
          }
          outboundShipmentId
          outboundShipment {
            poNumber
          }
        }
        nextToken
      }
      subtotal
      discount
      adjustment
      tax
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      paymentReferences
      notes
      customFields
      contact {
        name
        email
        phone
      }
      accountName
      accountId
      account {
        id
        businessName
        displayName
        email
        phone
        # fax removed 1.3.13
        # website
        externalId
        billingAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        billingContacts {
          name
          email
          phone
          description
        }
        billingEmail
        invoiceSubject
        invoiceAttachments
        invoiceCustomFields {
          id
          name
          type
          display
        }
      }
      attachments {
        bucket
        region
        key
        type
      }
      reloadYardId
      reloadYard {
        id
        name
        phone
        fax
        email
        website
        street
        city
        state
        zipCode
        country
        taxRates {
          taxCode
          taxRate
        }
        remittanceAddress {
          name
          street
          city
          state
          zipCode
          country
        }
        logoImage {
          bucket
          region
          key
        }
      }
      inboundShipmentId
      # used for detailed invoice memoe / manifest
      inboundShipment {
        shipFrom
        carrierName
        railCarNumber
        totalUOM
        tareWeight
        ladenWeight
        scaleWeightUnits
        placedDateTime
        releaseDateTime
        inventories {
          items {
            productCode
            productName
            quantityAdvised
            quantityReceived
            lotNumber
            customFields
          }
        }
        customFields
      }
      outboundShipmentId
      # used for detailed invoice memoe / manifest
      outboundShipment {
        pickupNumber
        shipTo {
          name
          street
          city
          state
          zipCode
          country
        }
        carrierName
        bolNumber
        railCarNumber
        departureDateTime
        tareWeight
        ladenWeight
        scaleWeightUnits
        totalUOM
        sealNumber
        shipmentLineItems {
          items {
            sortKey
            totalQuantityToPick
            inventoryId
            inventory {
              productCode
              productName
              lotNumber
            }
          }
          nextToken
        }
        customFields
      }
      createdAt
    }
  }
`;

export const invoiceServiceByInboundForValidation = /* GraphQL */ `
  query InvoiceServiceByInbound(
    $inboundShipmentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceByInbound(
      inboundShipmentId: $inboundShipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        invoiceId
        inboundShipmentId
      }
      nextToken
    }
  }
`;

//###############################################
// managerApp/InvoiceList
//###############################################
export const invoiceByActiveByStatusByDateByAccount = /* GraphQL */ `
  query InvoiceByActiveByStatusByDateByAccount(
    $reloadYardId: ID
    $activeStatusDueDateAccountName: ModelInvoiceInvoiceByActiveByStatusByDateByAccountCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByActiveByStatusByDateByAccount(
      reloadYardId: $reloadYardId
      activeStatusDueDateAccountName: $activeStatusDueDateAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        # owner removed 1.3.11
        # groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        paymentTerms
        dueDate
        overDue
        sentDate
        paidDate
        subtotal
        discount
        adjustment
        tax
        total
        balance
        accountName
        accountId
        account {
          # id removed 1.3.13
          businessName
          displayName
        }
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        createdAt
      }
      nextToken
    }
  }
`;

//###############################################
// customerApp/InvoiceList
//###############################################
export const invoiceByAccountByActiveByStatusByDate = /* GraphQL */ `
  query InvoiceByAccountByActiveByStatusByDate(
    $accountId: ID
    $activeStatusDueDate: ModelInvoiceInvoiceByAccountByActiveByStatusByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByAccountByActiveByStatusByDate(
      accountId: $accountId
      activeStatusDueDate: $activeStatusDueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        # owner removed 1.3.11
        # groups
        active
        status
        invoiceNumber
        externalId
        externalUrl
        externalStatus
        poNumber
        paymentTerms
        dueDate
        overDue
        sentDate
        paidDate
        subtotal
        discount
        adjustment
        tax
        total
        balance
        accountName
        accountId
        account {
          # id removed 1.3.13
          businessName
          displayName
        }
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        createdAt
      }
      nextToken
    }
  }
`;

export const searchInvoices = /* GraphQL */ `
  query SearchInvoices(
    $filter: SearchableInvoiceFilterInput
    $sort: SearchableInvoiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        # removed 1.3.11
        # owner
        # groups
        active
        status
        invoiceNumber
        externalUrl
        externalStatus
        poNumber
        paymentTerms
        dueDate
        overDue
        sentDate
        paidDate
        subtotal
        discount
        adjustment
        tax
        total
        balance
        accountName
        accountId
        account {
          id
          businessName
          displayName
        }
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        createdAt
      }
      nextToken
      total
    }
  }
`;
export const invoiceServiceByOutboundForValidation = /* GraphQL */ `
  query InvoiceServiceByOutbound(
    $outboundShipmentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceServiceByOutbound(
      outboundShipmentId: $outboundShipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        invoiceId
        outboundShipmentId
      }
      nextToken
    }
  }
`;

//###############################################
// managerApp/accounts/DeepDeleteButton
//###############################################
export const invoiceByAccountCount = /* GraphQL */ `
  query InvoiceByAccountByActiveByStatusByDate(
    $accountId: ID
    $activeStatusDueDate: ModelInvoiceInvoiceByAccountByActiveByStatusByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByAccountByActiveByStatusByDate(
      accountId: $accountId
      activeStatusDueDate: $activeStatusDueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const inboundShipmentByReloadYardByInvoice = /* GraphQL */ `
  query InboundShipmentByReloadYardByInvoice(
    $reloadYardId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByInvoice(
      reloadYardId: $reloadYardId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const outboundShipmentByReloadYardByInvoice = /* GraphQL */ `
  query OutboundShipmentByReloadYardByInvoice(
    $reloadYardId: ID
    $invoiceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByReloadYardByInvoice(
      reloadYardId: $reloadYardId
      invoiceId: $invoiceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const getInboundShipmentForInvoiceValidation = /* GraphQL */ `
  query GetInboundShipment($id: ID!) {
    getInboundShipment(id: $id) {
      id
      invoiceId
    }
  }
`;

export const getOutboundShipmentForInvoiceValidation = /* GraphQL */ `
  query GetOutboundShipment($id: ID!) {
    getOutboundShipment(id: $id) {
      id
      invoiceId
    }
  }
`;

// Invoice fields that buttons outside the edit form change (Record Payment,
// Complete, Send), read fresh before a write so a page left open can't send
// back stale values.
export const getInvoicePaymentState = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      active
      status
      invoiceNumber
      reloadYardId
      accountId
      accountName
      dueDate
      overDue
      paidDate
      total
      balance
      payments {
        id
        amount
        paymentDate
        method
        reference
        memo
        recordedBy
        recordedAt
      }
      updatedAt
    }
  }
`;
